import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';


@Component({
  selector: 'app-giveback',
  templateUrl: './giveback.component.html',
  styleUrls: ['./giveback.component.css']
})
export class GivebackComponent implements OnInit, AfterViewInit {

  constructor(private router: Router,private title: Title,private meta: Meta) { }

  ngOnInit() {

    this.title.setTitle('Honest Gorilla’s Giveback & Social Mission to Do Good');
    this.meta.updateTag({name: 'keywords', content: 'giveback,give back,social mission,commodity service,social good,light of unity initiative,so powerful is the light of unity,bahai quote,make a difference,light to the world,honest gorilla giveback program'});
    this.meta.updateTag({name: 'description', content: 'We are transforming energy as a commodity to a means for social good.Honest Gorilla was created to shed the light of unity while accompanying society to make this world a better, brighter place.'});
    this.meta.updateTag({name: 'author', content: 'HonestGorilla'});
    this.meta.updateTag({name: 'robots', content: 'index, follow'});
  }
  ngAfterViewInit(): void {
    $('.navbar-toggler').click(function () {
      $('.navbar').toggleClass('parent');
    });
  }

  // Lets go button: remove the smooth scroll
  letsgo() {
    const letsGo = document.getElementsByTagName('html');
      letsGo[0].classList.add('letsgo');
      this.router.navigateByUrl('/get-started');
  }
}
